// extracted by mini-css-extract-plugin
module.exports = {"tabActions":"style-module__tabActions___3fcKC","end":"style-module__end___2AwSU","spaced":"style-module__spaced___6tlDP"};